import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPostboxes } from '../../actions/postboxesActions';

const usePostboxes = () => {
	const dispatch = useDispatch<any>();
	const { postboxes, postboxesError, postboxesLoading } = useSelector(({ postboxesReducer }) => postboxesReducer);
	useEffect(() => {
		if (postboxes === null && !postboxesError && !postboxesLoading) {
			dispatch(fetchPostboxes());
		}
	}, [postboxes, postboxesError, postboxesLoading, dispatch]);

	return {
		postboxes,
		postboxesError,
		postboxesLoading,
	};
};

export default usePostboxes;
